import React from 'react';
import { useSelector } from 'react-redux';

import history from '../../../history';
import NotificationsBell from './NotificationsBell';
import AvatarCircle from '../ui/AvatarCircle';
import { MenuIcon } from '../ui/icons';

const Topbar = ({ title, actions, onHamburger }) => {
    const user = useSelector((s) => s.user);

    return (
        <header className="sticky top-0 z-20 border-b border-[#E5E7EB] px-4 sm:px-6 lg:px-8 py-3 bg-white/90" style={{ backdropFilter: 'blur(8px)' }}>
            <div className="flex items-center gap-3">
                <button
                    type="button"
                    onClick={onHamburger}
                    aria-label="Open menu"
                    className="lg:hidden rounded-xl p-2 -ml-2 text-[#6B7280] hover:bg-[#F5F6FA] hover:text-[#1F2937] transition-colors"
                >
                    <MenuIcon className="h-6 w-6" />
                </button>

                <h1 className="text-lg font-bold text-[#1F2937] truncate flex-1 min-w-0">{title}</h1>

                <div className="flex items-center gap-1 sm:gap-2">
                    {actions}
                    <NotificationsBell />
                    <button
                        type="button"
                        onClick={() => history.push('/admin/settings/user')}
                        className="flex items-center gap-2 rounded-xl p-1.5 sm:pl-3 hover:bg-[#F5F6FA] transition-colors"
                    >
                        <span className="hidden md:block text-sm text-[#6B7280]">
                            Hi, <span className="font-semibold text-[#1F2937]">{user.name}</span>
                        </span>
                        <AvatarCircle name={user.name} size="sm" />
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Topbar;
